import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Card, CardActions, CardContent, CardHeader, MenuItem, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import Grid from "@mui/material/Grid";
import {useForm} from "react-hook-form";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import clsx from "clsx";
import {diffDays} from "../../../../utils/GenericUtils";
import {bigNoteRegisterRequired} from "../../../../utils/RegisterUtils";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AnagraficaContext, AppContext} from "../../../../App";
import {addQuarantenaHistory, getQuarantenaHistory, updateQuarantena} from "../../../../services/QuaranteneServices";
import {FocolaioContext} from "../../focolai/detail/FocolaioDetailPage";
import {useParams} from "react-router-dom";
import {etichetteQuarantena, tipologieQuarantena, tipoMonitortaggio} from "../../../../utils/arrays/Generics";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {getDiario} from "../../../../services/AnagraficaServices";
import {ProtocolliContext} from "../../protocolli/detail/ProtocolloDetailPage";
import { Alert, AlertTitle } from '@mui/material';
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import CustomText from "../../../widgets/inputs/CustomText";

const QuarantenaInfoCard = ({tipoQuarantena, quarantena, setUpdateDiario}) => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	let context1 = useContext(ProtocolliContext);
	let context2 = useContext(FocolaioContext);
	const quarantenaContext = context1 ? context1 : context2;
	const [openInfo, setOpenInfo] = useState(false);
	
	const {control, handleSubmit, errors, register, watch, reset} = useForm({
		mode: "onChange",
		defaultValues: {...quarantena, protocollo: quarantena.protocollo ? "true" : "false", note: ""}
	});
	let {id} = useParams();
	const [submit, setSubmit] = useState(false);
	const [submitAdd, setSubmitAdd] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateQuarantena({
			...quarantena, ...quarantenaContext.state.quarantena, ...data
		}, quarantenaContext.dispatch);
		setSubmitAdd(true)
		addQuarantenaHistory({
			note: data.note,
		}, (quarantena ? quarantena.id : id), quarantenaContext.dispatch);
	}, [quarantenaContext.state.quarantena, quarantenaContext.dispatch, quarantena, id])
	
	useEffect(() => {
		if (quarantena) {
			reset({
				...quarantena,
				note: "",
				tag: quarantena.tag ? quarantena.tag : "",
				protocollo: quarantena.protocollo ? "true" : "false",
				score: quarantena.score ? quarantena.score : 0,
			});
		}
	}, [quarantena, reset])
	
	useEffect(() => {
		if (submitAdd && !quarantenaContext.state.loadingAddQuarantenaHistory && quarantenaContext.state.errorAddQuarantenaHistory === "") {
			setSubmitAdd(false);
			getQuarantenaHistory((quarantena ? quarantena.id : id), quarantenaContext.dispatch);
			setUpdateDiario(prevState => ++prevState);
		} else if (submitAdd && !quarantenaContext.state.loadingAddQuarantenaHistory && quarantenaContext.state.errorAddQuarantenaHistory !== "") {
			setSubmitAdd(false);
			setOpenSnackbar("error", quarantenaContext.state.errorAddQuarantenaHistory, appContext.dispatch);
		}
	}, [submitAdd, quarantenaContext.state.loadingAddQuarantenaHistory, quarantenaContext.state.errorAddQuarantenaHistory,
		appContext.dispatch, id, quarantena, quarantenaContext.dispatch, anagraficaContext.dispatch, setUpdateDiario])
	
	useEffect(() => {
		if (submit && !quarantenaContext.state.loadingUpdateQuarantena && quarantenaContext.state.errorUpdateQuarantena === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Informazioni aggiornate con successo!", appContext.dispatch);
			getQuarantenaHistory((quarantena ? quarantena.id : id), quarantenaContext.dispatch);
			getDiario(quarantena?.soggetto?.idSoggetto, anagraficaContext.dispatch)
		} else if (submit && !quarantenaContext.state.loadingUpdateQuarantena && quarantenaContext.state.errorUpdateQuarantena !== "") {
			setSubmit(false);
			setOpenSnackbar("error", quarantenaContext.state.errorUpdateQuarantena, appContext.dispatch);
		}
	}, [submit, quarantenaContext.state.loadingUpdateQuarantena, quarantenaContext.state.errorUpdateQuarantena, appContext.dispatch,
		id, quarantena, quarantenaContext.dispatch, anagraficaContext.dispatch])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Dettaglio {tipoQuarantena}</b></Typography>}
					subheader={<Tooltip title={"Giorni passati dall'inizio dell' autosorveglianza / isolamento"}>
						<Typography variant={"subtitle2"} color={"primary"}>
							<b>{diffDays(new Date(quarantena.dataInizio), new Date()) <= 1 ? diffDays(new Date(quarantena.dataInizio), new Date()) + "  " : diffDays(new Date(quarantena.dataInizio), new Date()) + " giorni passati "}
								/ {diffDays(new Date(quarantena.dataInizio), new Date(quarantena.dataFine))} totale giorni
								previsti</b>
						</Typography>
					</Tooltip>}
				/>
				<CardContent style={{flexGrow: 1}}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={6}>
								<CustomDateInput
									name={"dataInizio"}
									label={"Data inizio"}
									control={control}
									defaultValue={null}
									rules={{required: true}}
									error={errors["dataInizio"]}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomDateInput
									name={"dataFine"}
									label={"Data fine"}
									control={control}
									defaultValue={null}
									rules={{required: false}}
									error={errors["dataFine"]}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomSelect
									label={"Tipo di monitoraggio"}
									control={control}
									defaultValue={tipoMonitortaggio[0]}
									autoFocus={false}
									rules={{required: true}}
									name={"tipoMonitoraggio"}
									error={errors["tipoMonitoraggio"]}
								>
									{tipoMonitortaggio.map((val, key) => {
										return (
											<MenuItem value={val} key={key}>
												{val}
											</MenuItem>
										);
									})}
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomSelect
									label={"Stato"}
									control={control}
									defaultValue={"IN CORSO"}
									autoFocus={false}
									rules={{required: true}}
									name={"stato"}
									error={errors["stato"]}
								>
									{["NUOVA", "IN CORSO", "GUARITO", "CONCLUSA"].map((val, key) => {
										return (
											<MenuItem value={val} key={key}>
												{val}
											</MenuItem>
										);
									})}
								</CustomSelect>
							</Grid>
							
							{
								watch("stato") === "CONCLUSA" && new Date(watch("dataFine")).getTime() <= new Date().getTime() &&
								<Grid item xs={12}>
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Attenzione!</b></AlertTitle>
										La data di fine della autosorveglianza impostata è inferiore od uguale ad oggi e tu stai indicando
										l'Isolamento/autosorveglianza come concluso/a.
									</Alert>
								</Grid>
							}
							
							<Grid item xs={12} sm={5}>
								<CustomSelect
									label={"Tipo ordinanza"}
									control={control}
									autoFocus={false}
									rules={{required: true}}
									name={"tipo"}
									error={errors["tipo"]}
									defaultValue={tipologieQuarantena[0]}
								>
									{tipologieQuarantena.map((val, key) => {
										return (
											<MenuItem value={val} key={key}>
												{val === "Quarantena" ? "Autosorveglianza" : val}
											</MenuItem>
										);
									})}
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={2}>
								<CustomSelect
									label={"Score"}
									control={control}
									autoFocus={false}
									defaultValue={0}
									rules={{required: true}}
									name={"score"}
									error={errors["score"]}
								>
									{[0, 1, 2, 3, 4].map((val, key) => {
										return (
											<MenuItem value={val} key={key}>
												{val}
											</MenuItem>
										);
									})}
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={5}>
								<CustomSelect
									label={"Accetta tampone"}
									control={control}
									autoFocus={false}
									defaultValue={"true"}
									rules={{required: true}}
									name={"protocollo"}
									error={errors["protocollo"]}
								>
									<MenuItem value={"true"}>
										Sì
									</MenuItem>
									<MenuItem value={"false"}>
										No
									</MenuItem>
								</CustomSelect>
							</Grid>
							<Grid item xs={12}>
								<CustomText
									control={control}
									rules={{required: true}}
									name={"indirizzo"}
									label={"Indirizzo isolamento / autosorveglianza"}
									autoFocus={false}
									error={errors["indirizzo"]}
								/>
							</Grid>
							<Grid item xs={12}>
								<CustomMultiText
									inputRef={register(bigNoteRegisterRequired)}
									label={"Note"}
									autoFocus={false}
									name={"note"}
									error={errors["note"]}
									rows={5}
								/>
							</Grid>
							
							<Grid item xs={12}>
								<CustomSelect
									name={"tag"}
									label={"Assegna un'etichetta all'ordinanza"}
									control={control}
									defaultValue={""}
									none={true}
									noneValue={""}
									autoFocus={false}
									rules={{required: false}}
									error={errors["tag"]}
								>
									{
										etichetteQuarantena.map((item) => {
											return (
												<MenuItem value={item} key={item}>
													{item}
												</MenuItem>
											)
										})
									}
								</CustomSelect>
							</Grid>
						</Grid>
					</form>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Chiarimenti su stato, date e score"}>
						<Button variant={"text"} disableElevation size="small"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={() => setOpenInfo(true)}>
							<b>Info</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Modifica le informazioni dell' autosorveglianza / isolamento: forza lo score, cambia date o tipo, ..."}>
						<Button variant={"contained"} disableElevation size="small"
						        style={{borderRadius: 24}} color={"primary"}
						        className={classes.roundButton} onClick={handleSubmit(onSubmit)}>
							<b>Aggiorna informazioni</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
			
			{
				openInfo &&
				<SimpleDialog
					open={openInfo}
					handleClose={() => setOpenInfo(false)}
					title={"Informazioni sull' autosorveglianza"}
					maxWidth={"md"}
					content={
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<Typography color={"primary"}>
									<b>Stato di un isolamento o autosorveglianza</b>
								</Typography>
								<ul>
									<li><b>NUOVA</b>: Isolamento o Autosorveglianza appena create, è necessario verificare le date e la
										prenotazione del tampone. Una volta effettuate camio in "IN CORSO"
									</li>
									<li><b>IN CORSO</b>: Isolamento o Autosorveglianza in cui almeno un operatore ci ha messo mano. Non
										necessariamente serve l'intervento "umano": solo se lo score è alto o se noto anomalie.
									</li>
									<li><b>GUARITO</b>: Paziente che ha concluso l'isolamento o l'autosorveglianza che necessita di essere
										caricato su Gestione pazienti.
									</li>
									<li><b>CONCLUSA</b>: Paziente che ha concluso l'isolamento o l'autosorveglianza caricata anche su
										Gestione
										pazienti. Non dovresti più metterci mano.
									</li>
								</ul>
							</Grid>
							<Grid item xs={12}>
								<Typography color={"primary"}>
									<b>Date dell' isolamento o dell'autosorveglianza</b>
								</Typography>
								<ul>
									<li><b>DATA INIZIO</b>: Data di inizio dell'autosorveglianza o dell'isolamento (Verificare correttezza
										in
										base a sintomi dell'intervista o dati tampone).
									</li>
									<li><b>DATA FINE</b>: Data ipotetica di fine dell'isolamento (puoi usare il giorno dopo la
										prenotazione del tampone, così dovresti conoscere l'esito)
									</li>
								</ul>
							</Grid>
							<Grid item xs={12}>
								<Typography color={"primary"}>
									<b>Calcolo dello score (Isolamento)</b>
								</Typography>
								<ul>
									<li><b>1</b>: nessun sintomo, alterazione gusto, alterazione olfatto
									</li>
									<li><b>2</b>: vertigini, dolori muscolari, inappetenza, malessere generale, cefalea ,tosse inferiore a
										15 colpi, diarrea meno di 3 scariche
									</li>
									<li><b>3</b>: diarrea superiore a 3 scariche, tosse superiore a 15 colpi, mal di gola
									</li>
									<li><b>4</b>: difficoltà respiratorie
									</li>
								</ul>
							</Grid>
						</Grid>
					}
				/>
			}
		</React.Fragment>
	);
};

export default React.memo(QuarantenaInfoCard);
